import { Alert, Button, Modal, Table, TableColumnsType } from 'antd';
import { useResponsive } from '~/hooks';

interface BalanceObject {
  id: number;
  optType: string;
  price: number;
}

const dataSource: BalanceObject[] = [
  {
    id: 1,
    optType: '文件上传',
    price: 0.08,
  },
  {
    id: 2,
    optType: '视频编辑插件',
    price: 0.05,
  },
  {
    id: 3,
    optType: '邮件发送接口',
    price: 0.05,
  },
];

const BalanceModal = ({ open, onHideModal }: any) => {
  const { isMobile } = useResponsive();
  const columns: TableColumnsType<BalanceObject> = [
    { title: '插件', dataIndex: 'optType' },
    {
      title: '价格 (积分/次)',
      dataIndex: 'price',
    },
  ];
  return (
    <Modal
      open={open}
      title="计费标准"
      width={isMobile ? 400 : 600}
      onCancel={onHideModal}
      footer={[
        <Button key="cancel" onClick={onHideModal} type="primary">
          知道了
        </Button>,
      ]}
      centered
    >
      <div className="mt-3"></div>
      <Alert
        message="仅当您使用需 API Key 的接口时会计费，其余所有接口均可免费无限次调用。"
        type="info"
        showIcon
      />
      <Table<BalanceObject>
        size="small"
        className="mt-2"
        columns={columns}
        dataSource={dataSource}
        pagination={false}
      />
    </Modal>
  );
};
export default BalanceModal;
